import type { Route } from "./+types/products.drive";
import { ProductPdpTemplate } from "~/components/products/pdp/ProductPdpTemplate";
import { DRIVE_PRODUCT } from "~/data/products/drive";
import { getProductRatings, getAppRatings, combineRatings, toStoreRatings } from "~/lib/madisongwapi.server";
import { getProductReviews } from "~/lib/reviews.server";
import { REVIEWS_PRODUCT_ID } from "~/lib/reviews";

export const handle = { sitemap: { title: "Bouncie Drive" } };

export async function loader(_args: Route.LoaderArgs) {
  const [productRatings, appRatings, reviews] = await Promise.all([
    getProductRatings(),
    getAppRatings(),
    getProductReviews({ productId: REVIEWS_PRODUCT_ID }),
  ]);
  const combinedRating = combineRatings(productRatings, appRatings);
  return { combinedRating, storeRatings: toStoreRatings(productRatings, appRatings), reviews };
}

export default function ProductsDrive({ loaderData }: Route.ComponentProps) {
  const { combinedRating, storeRatings, reviews } = loaderData;

  const content = {
    ...DRIVE_PRODUCT,
    hero: { ...DRIVE_PRODUCT.hero, ...(combinedRating ?? {}) },
    reviews: { ...DRIVE_PRODUCT.reviews, appRatings: storeRatings, reviews },
  };

  return <ProductPdpTemplate content={content} />;
}
